import { Button, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { RiArrowDropDownLine } from 'react-icons/ri'
import { deleteMapPointer, getMapPointers, postMapPointer, putMapPointer } from '../../services/API/MapPointerAPI';
import useAuth from '../../hooks/useAuth';
import useShowNotification from '../../hooks/useShowNotification';
import useAsyncCallWithLoader from '../../hooks/useAPICallWithLoader';

const AdminMapPage = () => {
  const [mapPointers, setMapPointers] = useState(null);
  const [isNewMapPointerPanelOpen, setIsNewMapPointerPanelOpen] = useState(false);
  const { auth } = useAuth();
  const { showSuccessNotification } = useShowNotification();

  const fetchMapInfo = async () => {
    const mapPointers = await getMapPointers()
    setMapPointers(mapPointers);
  }

  const onScreenOpenFetchMapInfo = useAsyncCallWithLoader(fetchMapInfo);

  const addMapPointer = async (mapPointer) => {
    const res = await postMapPointer(mapPointer, auth.token);
    if (res.status === 201) {
      showSuccessNotification(`'${mapPointer.country}' successfully added!`)
      await fetchMapInfo();
      setIsNewMapPointerPanelOpen(x => !x);
    }
  }

  const onAddMapPointer = useAsyncCallWithLoader(addMapPointer);

  useEffect(() => {
    onScreenOpenFetchMapInfo();
  }, [])

  const updateMapPointer = async (countryPointer) => {
    const mapPointerResponse = await putMapPointer(countryPointer, auth.token);
    if (mapPointerResponse.status === 201) {
      showSuccessNotification(`'${mapPointerResponse.data.country}' is updated!`)
      await fetchMapInfo();
    }
  }

  const onUpdateMapPointer = useAsyncCallWithLoader(updateMapPointer);

  const removeMapPointer = async (countryPointer) => {
    const res = await deleteMapPointer(countryPointer, auth.token);
    if (res.status === 204) {
      showSuccessNotification(`'${countryPointer.country}' successfully deleted!`);
      await fetchMapInfo();
    }
  }

  const onRemoveMapPointer = useAsyncCallWithLoader(removeMapPointer);
  
  const newMapPointerInitialValues = {
    country: "",
    latitude: "",
    longitude: "",
    color: "#000000"
  }

  return (
    <div className="admin-page">
      <div className="admin-page__header">
        <h1 className="admin-page__title">Kaart</h1>
      </div>
      <div className="admin-page__toolbar">
        <Button variant="outlined" className="admin-blog-list__btn-new" onClick={undefined}> 
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M7 1v12M1 7h12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
          New pointer
        </Button>
      </div>
      <div>
        {mapPointers?.map(country => {
          return <MapItem key={country.id} item={country} onUpdate={onUpdateMapPointer} onDelete={onRemoveMapPointer}/>
        })}
      </div>
    {/*  TODO: Misschien een map preview toevoegen? */}
    </div>
  )
}

// const CountryEditRow = ({countryData, fetchMapPointers}) => {
//   const [showEditPanel, setShowEditPanel] = useState(false);
//   const { auth } = useAuth();
//   const { showSuccessNotification } = useShowNotification();
//
//  
//
//   return (
//     <div style={{borderStyle: 'solid', padding: 10, width: "100%"}} >
//       <div className='admin-map-page__country-edit-row' onClick={() => setShowEditPanel(oldState => !oldState)}>
//         <div style={{marginRight: 10}}>
//           {countryData.country}
//         </div>
//         <div style={{marginLeft: 10}}>{`(${countryData.latitude}, ${countryData.longitude})`}</div>
//         <RiArrowDropDownLine
//           fontSize={50}
//           style={showEditPanel ? {transform: "rotate(180deg)"} : {}}
//           className="admin-map-page__dropdown-icon"
//         />
//       </div>
//       { showEditPanel && 
//       <CountryEditPanel 
//         countryData={countryData}
//         onCancel={onRemoveMapPointer}
//         onConfirm={onUpdateMapPointer}
//         confirmLabel="Update"
//         cancelLabel="Verwijderen"
//       />}
//     </div>
//   )
// }


const MapItem = ({ item, onUpdate, onDelete }) => {
  const [expanded, setExpanded] = useState(false);
  const [form, setForm] = useState({
    country: item.country,
    latitude: item.latitude,
    longitude: item.longitude,
    color: item.color,
  });

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleUpdate = () => {
    onUpdate({ ...item, ...form });
  };

  return (
    <div className="map-item">
      <div className="map-header" onClick={() => setExpanded(prev => !prev)}>
        <div className="map-header-left">
          <div className="map-dot" style={{ background: form.color }} />
          <span className="map-name">{form.country}</span>
        </div>
        <div className="map-header-right">
          <span className="map-coords">({item.latitude}, {item.longitude})</span>
          <span className="map-chevron">{expanded ? '▲' : '▼'}</span>
        </div>
      </div>

      {expanded && (
        <div className="map-body">
          <div className="map-field map-full">
            <label>Country</label>
            <input
              type="text"
              value={form.country}
              onChange={e => handleChange('country', e.target.value)}
            />
          </div>

          <div className="map-field">
            <label>Latitude</label>
            <input
              type="number"
              value={form.latitude}
              onChange={e => handleChange('latitude', e.target.value)}
            />
          </div>

          <div className="map-field">
            <label>Longitude</label>
            <input
              type="number"
              value={form.longitude}
              onChange={e => handleChange('longitude', e.target.value)}
            />
          </div>

          <div className="map-field map-full">
            <label>Color</label>
            <div className="map-field-color">
              <input
                type="color"
                value={form.color}
                onChange={e => handleChange('color', e.target.value)}
              />
              <span>{form.color}</span>
            </div>
          </div>

          <div className="map-actions">
            <button className="btn-delete" onClick={() => onDelete(item.id)}>
              Delete
            </button>
            <button className="btn-update" onClick={handleUpdate}>
              Update
            </button>
          </div>
        </div>
      )}
    </div>
  );
};


const CountryEditPanel = ({countryData, onConfirm, onCancel, confirmLabel, cancelLabel}) => {
  const [countryPointer, setCountryPointer] = useState(countryData);

  return (
    <div className='admin-map-page__country-edit-panel'> 
      <div className='admin-map-page__country-edit-panel__row'>
        <div style={{flex: 1}}>
          Land:
        </div>
        <TextField
          style={{flex: 1}}
          value={countryPointer?.country}
          onChange={(e) => setCountryPointer({...countryPointer, country: e.target.value.trim()})}
        />
      </div>
      <div className='admin-map-page__country-edit-panel__row'>
        <div style={{flex: 1}}>
          Coordinaten:
        </div>
        <div style={{flex: 1}}>
          <TextField
            style={{flex: 1}}
            value={countryPointer?.latitude}
            type='number'
            onChange={(e) => setCountryPointer({...countryPointer, latitude: parseFloat(e.target.value)})}
          />
          <TextField 
            style={{flex: 1}}
            value={countryPointer?.longitude}
            type='number'
            onChange={(e) => setCountryPointer({...countryPointer, longitude: parseFloat(e.target.value)})}
          />
        </div>
      </div>
      <div className='admin-map-page__country-edit-panel__row'>
        <div style={{flex: 1}}>
          Kleur:
        </div>
        <TextField
          style={{flex: 1}}
          type='color'
          fullWidth
          value={countryPointer?.color}
          onChange={(e) => setCountryPointer({...countryPointer, color: e.target.value})}
        />
      </div>
      <div className='admin-map-page__country-edit-panel__buttons-container'>
        <Button
          sx={{mt: 2}}
          variant='outlined'
          onClick={() => onCancel(countryPointer)}
        >
          {cancelLabel}
        </Button>
        <Button
          sx={{mt: 2}}
          variant='contained'
          onClick={() => onConfirm(countryPointer)}
        >
          {confirmLabel}
        </Button>
      </div>
    </div>
  )
}

export default AdminMapPage
